import { newUuid } from '@overlayqa/shared';
import { apiBaseUrl } from './apiBaseUrl';

export const EXTENSION_AUTH_REQUEST_EVENT = 'overlayqa-extension-auth-request';
export const EXTENSION_AUTH_FAILED_EVENT = 'overlayqa-extension-auth-failed';

/** A sent credential is not an installed session. Wait for the storage write's response. */
export function acknowledgeExtensionAuth(payload: { userId: string; teamId: string; sessionToken: string }, timeoutMs = 10_000): Promise<void> {
  return new Promise((resolve, reject) => {
    const requestId = newUuid();
    const cleanup = () => { clearTimeout(timer); window.removeEventListener('message', receive); };
    const receive = (event: MessageEvent) => {
      if (event.source !== window || event.origin !== window.location.origin
        || event.data?.type !== 'OVERLAYQA_DASHBOARD_AUTH_RESULT' || event.data.requestId !== requestId) return;
      const result = event.data.result;
      cleanup();
      if (result?.ok === true && result.userId === payload.userId && result.teamId === payload.teamId) resolve();
      else reject(new Error('The extension could not connect to this account. Try again.'));
    };
    const timer = setTimeout(() => {
      cleanup();
      reject(new Error('The extension did not respond. Update it in Chrome and try again.'));
    }, timeoutMs);
    window.addEventListener('message', receive);
    window.postMessage({ type: 'OVERLAYQA_DASHBOARD_AUTH', apiOrigin: apiBaseUrl(), payload, requestId }, window.location.origin);
  });
}
